import {
  makeListState,
  makePaginationState,
  STATUSES,
  concatUnique,
} from 'app/utils/redux';

import * as t from './types';


const initialState = {
  banners: makeListState(),
  stories: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch stories
    case `${t.FETCH_STORIES}_PENDING`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_STORIES}_SUCCESS`:
      return {
        ...state,
        stories: {
          sectionId: action.meta.sectionId,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(state.stories.pagination.items, action.payload.result.items),
          },
        },
      };
    case `${t.FETCH_STORIES}_ERROR`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.ERROR,
          isLoaded: false,
        },
      };

    // fetch section banners
    case `${t.FETCH_SECTION_BANNERS}_PENDING`:
      return {
        ...state,
        banners: {
          ...state.banners,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_SECTION_BANNERS}_SUCCESS`:
      return {
        ...state,
        banners: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_SECTION_BANNERS}_ERROR`:
      return {
        ...state,
        banners: {
          ...state.banners,
          status: STATUSES.ERROR,
        },
      };

    // reset
    case t.RESET:
      return {
        ...state,
        stories: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/curationList/reducer.js